import { useState } from 'react';
import type { FormEvent } from 'react';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/da229l3k8r5te5mqse9g';

export default function Newsletter() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get('company_alt') || '').trim();
    if (honeypot) {
      setStatus('success');
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key === 'company_alt') return;
      if (value instanceof File) {
        payload.append(key, 'Uncollectable');
        return;
      }
      payload.append(key, String(value));
    });

    try {
      const res = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      const isSpam = /spam|form data is spam/i.test(serverMsg);

      if (res.ok && parsed?.code === 'OK' && !isSpam) {
        setStatus('success');
        setFormError('');
        form.reset();
      } else {
        setStatus('error');
        setFormError(serverMsg || '提交失败，请稍后再试。');
      }
    } catch {
      setStatus('error');
      setFormError('网络异常，请稍后再试。');
    }
  };

  return (
    <div>
      <h3 className="font-seal text-2xl text-primary-700">追更不迷路</h3>
      <p className="mt-3 text-sm leading-6 text-foreground-600">
        留下邮箱，新一季上线、人物关系图更新、高甜名场面盘点时，第一时间提醒你。绝不错过每一口糖。
      </p>
      <form id="newsletter-form" data-readdy-form onSubmit={handleSubmit} className="mt-5" noValidate>
        <div className="flex flex-col gap-3 sm:flex-row">
          <input
            type="email"
            name="email"
            required
            placeholder="输入你的邮箱地址"
            aria-label="邮箱地址"
            className="h-12 flex-1 rounded-md border border-background-300 bg-background-50 px-4 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
          <button
            type="submit"
            className="h-12 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            订阅追更
          </button>
        </div>
        <div className="hp-guard" aria-hidden="true">
          <label htmlFor="company_alt">公司</label>
          <input type="text" id="company_alt" name="company_alt" tabIndex={-1} autoComplete="off" readOnly />
        </div>
        {status === 'success' && (
          <p className="mt-3 flex items-center gap-1.5 text-sm text-secondary-700">
            <i className="ri-checkbox-circle-line" />
            订阅成功啦，糖点更新会第一时间送达。
          </p>
        )}
        {status === 'error' && (
          <p className="mt-3 flex items-center gap-1.5 text-sm text-primary-700">
            <i className="ri-error-warning-line" />
            {formError}
          </p>
        )}
      </form>
    </div>
  );
}